<template>
  <div class="form-group">
    <label>{{ title }}</label>

    <div class="d-flex">
      <input
        type="color"
        v-model="theValue"
      >

      <input
        v-model="theValue"
        :class="{ 'is-invalid': errors && errors.length > 0 }"
        :placeholder="placeholder"
        type="text"
        class="form-control"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    default: {
      required: false,
      type: String,
      default: '#f46a3f',
    },
  },

  data () {
    return {
      theValue: null,
    }
  },

  watch: {
    theValue () {
      this.$emit('input', this.theValue)
    },

    value () {
      this.theValue = this.value
    },
  },

  mounted () {
    this.theValue = this.value || this.default
  },

  computed: {
    squaredStyle () {
      return {backgroundColor: this.theValue || this.default}
    },
  },
}
</script>

<style>
  input[type=color] {
    height: 39px;
    border: 1px solid #eaeaea;
    border-right: none;
  }
</style>
